import React, { FunctionComponent } from 'react';
import { AccountBoxOutlined, GroupWorkOutlined } from '@mui/icons-material';

import { Sidebar } from './sidebar';

export const PermanentLeft: FunctionComponent = () => {
  return (
    <Sidebar
      items={[
        { title: 'Accounts', icon: <AccountBoxOutlined /> },
        { title: 'GFI Products', icon: <GroupWorkOutlined /> },
      ]}
      variant="permanent"
      anchor="left"
    />
  );
};

export const PermanentRight: FunctionComponent = () => {
  return (
    <Sidebar
      items={[
        { title: 'Accounts', icon: <AccountBoxOutlined /> },
        { title: 'GFI Products', icon: <GroupWorkOutlined /> },
      ]}
      variant="permanent"
      anchor="right"
    />
  );
};
